module.exports = __webpack_public_path__ + "static/media/logo.36f273f5.png";